import { render, staticRenderFns } from "./skuManage.vue?vue&type=template&id=76c68cf7&scoped=true&"
import script from "./skuManage.vue?vue&type=script&lang=js&"
export * from "./skuManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c68cf7",
  null
  
)

export default component.exports